module.exports = __webpack_public_path__ + "static/img/partner-coingecko.7b371c0e.png";